import React, {useContext, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {Card, CardContent, FormControlLabel, Radio, RadioGroup} from "@mui/material";
import {FormattedMessage} from "react-intl";
import {grey300, greyishBlue500} from "../../../../../../../../assets/jss/main";
import BottomDrawer from "../../../../../../../../components/WMS/Mobile/BottomDrawer";
import ToggleNavigation from "../../../../../../../../components/WMS/Mobile/Toggle/ToggleNavigation";
import Toggle from "../../../../../../../../components/WMS/Mobile/Toggle/Toggle";
import {WMSContext} from "../../../../../../context/WMSContext";
import CustomButton from "../../../../../../../../components/CustomButton";
import {getWMSContainers} from "../../../../../../../../api/wms/wmsContainers/wmsContainers";
import {WmsItemsStatus} from "../../../../../../../../utils/WmsItemsStatus";
import {WmsContainerType} from "../../../../../../../../utils/WMSContainerType";
import BeatLoaderRegular from "../../../../../../../../components/loaders/BeatLoaderRegular";

DropZoneOrTrolleyDrawer.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    handleZoneOrTrolleySelection: PropTypes.func.isRequired,
    currentShipment: PropTypes.object.isRequired,
    isCC: PropTypes.bool,
    isCCInternalWMSShip: PropTypes.bool
};

function DropZoneOrTrolleyDrawer({open, handleClose, handleZoneOrTrolleySelection, currentShipment, isCC=false, isCCInternalWMSShip = null}) {
    const {currentInventory, currentOrganization} = useContext(WMSContext)
    const [trolleyOrZone, setTrolleyOrZone] = useState(0)
    const [choiceValue, setChoiceValue] = useState()
    const [trolleys, setTrolleys] = useState()
    const [zones, setZones] = useState()
    const [loading, setLoading] = useState(true)

    const handleChange = (event) => {
        let isTrolley = false
        if (trolleyOrZone === 1) {
            isTrolley = true
        }
        setChoiceValue({
            isTrolley: isTrolley,
            containerCodebar: event.target.value
        })
    };


    function getContainers() {
        let tipperOrCCContainer = WmsContainerType.TIPPER

        if (isCC && !isCCInternalWMSShip) {
            tipperOrCCContainer = WmsContainerType.CC
        }

        const typeParameter = `type[]=${WmsContainerType.TROLLEY}&type[]=${tipperOrCCContainer}`

        return getWMSContainers(currentInventory.id, typeParameter);
    }

    function getEligibleTrolleys(trolleys) {
        return trolleys.filter(trolley => (
            trolley.wmsItems.length === 0
            || trolley.wmsItems.every(item => item.status === WmsItemsStatus.READY_TO_BE_SHIPPED)
        ));
    }

    useEffect( () => {
        if (!open) return;

        getContainers().then((containers) => {
            let trolleys = containers.filter((container) => container.type === WmsContainerType.TROLLEY);

            let retrievedZones = containers.filter((container) => container.type !== WmsContainerType.TROLLEY);

            if (true === currentOrganization.containerToShippingMethodMatch && (retrievedZones.length > 0 || trolleys.length > 0)) {
                retrievedZones = retrievedZones.filter((retrievedZone) => retrievedZone.shippingMethods?.some(sm => sm.id === currentShipment.shippingMethod?.id) || 0 === retrievedZone.shippingMethods.length)
                trolleys = trolleys.filter((trolley) => trolley.shippingMethods?.some(sm => sm.id === currentShipment.shippingMethod?.id) || 0 === trolley.shippingMethods.length)
            }

            trolleys = getEligibleTrolleys(trolleys);

            setTrolleys(trolleys);

            setZones(retrievedZones);

            setLoading(false)
        }).finally(() => {
            setLoading(false)
        })
    }, [open, currentInventory, currentOrganization]);

    return (
        <BottomDrawer
            open={open}
            onClose={handleClose}
            openMaxHeight
            noHeightLimit
            disablePortal
            title={
                <span style={{
                    fontSize: "16px",
                    fontWeight: 600
                }}>
                    <FormattedMessage id={"wms.packing.manualDropZoneChoice.title"}/>
                </span>
            }
            subtitle={
                <span style={{
                    color: greyishBlue500,
                    fontWeight: 400,
                    fontSize: "14px"
                }}>
                        <FormattedMessage id={"wms.packing.manualDropZoneChoice.subtitle"}/>
                </span>
            }
        >
            <div style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                height: "100%"
            }}>
                <div>
                    <Card>
                        <CardContent>
                            <div style={{
                                margin: "auto",
                                width: "fit-content"
                            }}>
                                <ToggleNavigation
                                    value={trolleyOrZone}
                                    onChange={(value) => {
                                        setTrolleyOrZone(value)
                                    }}
                                >
                                    <Toggle label={<FormattedMessage id={"wms.packing.manualDropZoneChoice.filterTag.zone"}/>} large/>
                                    <Toggle label={<FormattedMessage id={"wms.packing.manualDropZoneChoice.filterTag.trolley"}/>} large/>
                                </ToggleNavigation>
                            </div>
                        </CardContent>
                    </Card>

                    {loading && (
                        <div style={{margin: "8px auto", width: "fit-content"}}>
                            <BeatLoaderRegular loading={true} size={15} />
                        </div>
                    )}

                    <RadioGroup
                        onChange={handleChange}
                        value={choiceValue}
                    >
                        {zones && 0 === trolleyOrZone && (
                            zones.map((zone) => (
                                <Card>
                                    <CardContent style={{padding: 0}}>
                                        <FormControlLabel
                                            value={zone.codebar}
                                            sx={{
                                                display: "flex",
                                                flexDirection: "row-reverse",
                                                justifyContent: "space-between",
                                                margin: 0,
                                                padding: "16px",
                                                ':hover': {
                                                    backgroundColor: grey300,
                                                },
                                            }}
                                            control={<Radio/>}
                                            label={zone.name}
                                        />
                                    </CardContent>
                                </Card>
                            ))
                        )}
                        {trolleys && 1 === trolleyOrZone && (
                            trolleys.map((trolley) => (
                                <Card>
                                    <CardContent style={{padding: 0}}>
                                        <FormControlLabel
                                            value={trolley.codebar}
                                            sx={{
                                                display: "flex",
                                                flexDirection: "row-reverse",
                                                justifyContent: "space-between",
                                                margin: 0,
                                                padding: "16px",
                                                ':hover': {
                                                    backgroundColor: grey300,
                                                },
                                            }}
                                            control={<Radio/>}
                                            label={trolley.name}
                                        />
                                    </CardContent>
                                </Card>
                            ))
                        )}
                    </RadioGroup>
                </div>
                <div style={{
                    padding: "16px"
                }}>
                    <CustomButton
                        fullWidth
                        disabled={!choiceValue}
                        onClick={() => handleZoneOrTrolleySelection(choiceValue)}
                    >
                        <FormattedMessage id={"wms.packing.manualDropZoneChoice.buttonLabel"}/>
                    </CustomButton>
                </div>
            </div>
        </BottomDrawer>
    );
}

export default DropZoneOrTrolleyDrawer;
